import type React from 'react';
import { styled, css } from 'styled-components';

export const Wrapper = styled.div<{ $formActive?: boolean }>`
  min-height: 38px;
  flex: 0 0 auto;
  * {
    flex: 0 0 100%;
  }
  ${({ $formActive, theme }) =>
    !$formActive &&
    css`
      display: flex;
      align-items: center;
      padding: 8px 12px;
      font-size: 14px;
      border-radius: 4px;
      border: 1px solid ${theme.colors.grey30_1};
      color: ${theme.colors.black_1};
      background: ${theme.colors.grey00_7};
    `}
`;

export interface IText {
  value?: string;
  children?: React.ReactElement;
  formActive: boolean;
  onDoubleClick: () => void;
}

const PseudoText: React.FC<IText> = ({ children, value, formActive, onDoubleClick }) => (
  <Wrapper onDoubleClick={onDoubleClick} $formActive={formActive}>
    {formActive ? children : value}
  </Wrapper>
);

export default PseudoText;
